import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <nav className={`rk-navbar${scrolled ? ' scrolled' : ''}`} aria-label="Primary">
        <div className="rk-navbar-inner">
          <Link to="/" className="rk-logo" onClick={() => setMenuOpen(false)}>
            <div className="rk-logo-icon">
              <i className="bi bi-shield-fill" aria-hidden="true"></i>
            </div>
            <div>
              <span className="rk-logo-text">RAKSHA</span>
              <span className="rk-logo-sub">Ireland</span>
            </div>
          </Link>

          <ul className="rk-nav-links">
            <li><NavLink to="/how-it-works">How It Works</NavLink></li>
            <li><NavLink to="/features">Features</NavLink></li>
            <li><NavLink to="/safety">Safety &amp; Trust</NavLink></li>
            <li><NavLink to="/blog">Blog</NavLink></li>
            <li><NavLink to="/contact">Contact</NavLink></li>
          </ul>

          <Link
            to="/#waitlist"
            className="rk-download-btn"
            onClick={() => setMenuOpen(false)}
          >
            <i className="bi bi-envelope-plus-fill" aria-hidden="true"></i>&nbsp;Join Waitlist
          </Link>

          <button
            className="rk-hamburger"
            onClick={() => setMenuOpen(o => !o)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            aria-controls="rk-mobile-menu"
          >
            <i className={`bi ${menuOpen ? 'bi-x-lg' : 'bi-list'}`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      <div
        id="rk-mobile-menu"
        className={`rk-mobile-menu${menuOpen ? ' open' : ''}`}
        hidden={!menuOpen}
      >
        <NavLink to="/" end onClick={() => setMenuOpen(false)}>Home</NavLink>
        <NavLink to="/how-it-works" onClick={() => setMenuOpen(false)}>How It Works</NavLink>
        <NavLink to="/features" onClick={() => setMenuOpen(false)}>Features</NavLink>
        <NavLink to="/safety" onClick={() => setMenuOpen(false)}>Safety &amp; Trust</NavLink>
        <NavLink to="/blog" onClick={() => setMenuOpen(false)}>Blog</NavLink>
        <Link to="/#faq" onClick={() => setMenuOpen(false)}>FAQ</Link>
        <NavLink to="/privacy-policy" onClick={() => setMenuOpen(false)}>Privacy Policy</NavLink>
        <NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact</NavLink>
        <Link
          to="/#waitlist"
          className="rk-mobile-download"
          onClick={() => setMenuOpen(false)}
        >
          <i className="bi bi-envelope-plus-fill"></i> Join the Android beta waitlist
        </Link>
      </div>
    </>
  );
}
